import React from 'react';
import { BadgeCheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { images } from '../data/site';
const badges = ['Yamaha Outboard Certified Technician', 'Honda Marine Certified Tech'];
export function MeetMichael() {
  return <section id="about" aria-labelledby="about-title" className="grid w-full scroll-mt-24 bg-sand lg:grid-cols-2" data-id="element-228" data-mp="1j4ujzdipqfa8">
      <div className="relative min-h-[380px] lg:min-h-[640px]" data-id="element-229" data-mp="1a696hws3lqgb">
        <img src={images.michaelBoat} alt="Michael's center console boat on the open water near Edenton, North Carolina" loading="lazy" className="absolute inset-0 h-full w-full object-cover" data-id="element-230" data-mp="1a7tz3guuqzbj" />
      </div>
      <div className="gutter flex flex-col justify-center py-14 md:py-20" data-id="element-231" data-mp="v9i4dfr1i0n0">
        <Reveal data-id="element-232" data-mp="vbco4qqkrmpi">
          <h2 id="about-title" className="display text-[clamp(3rem,6vw,7rem)] font-extrabold text-navy" data-id="element-233" data-mp="2ulufsj49rc90">
            Meet Michael
          </h2>
          <div className="mt-6 max-w-[60ch] space-y-5 text-lg leading-relaxed text-ink-muted" data-id="element-234" data-mp="2pnj19v314dkg">
            <p data-id="element-235" data-mp="2cpuqx5sd7krn">
              Michael is a lifelong Eastern North Carolina waterman. He’s spent his life on the water, with more than a decade of hands-on
              marine experience on tugboats, ferries and commercial vessels. He worked alongside Barry as a technician at Soundside Marine
              Repairs before taking over the shop.
            </p>
            <p className="border-l-4 border-water pl-5 text-xl font-medium text-navy-900" data-id="element-236" data-mp="2vhdtjbih8wt5">
              Our promise: honest service, quality repairs, fair pricing, and the kind of care that keeps you coming back.
            </p>
          </div>
          <ul className="mt-8 flex flex-wrap gap-3" data-id="element-237" data-mp="2lrkqx00bbs11">
            {badges.map(b => <li key={b} className="inline-flex items-center gap-2 rounded-full bg-navy px-4 py-2.5 text-sm font-semibold text-white" data-id="element-238" data-mp="2qpw0raqly2j9">
                <BadgeCheckIcon className="h-4 w-4 text-water-300" aria-hidden="true" data-id="element-239" data-mp="3eeyh8f9i9pc6" />
                {b}
              </li>)}
          </ul>
        </Reveal>
      </div>
    </section>;
}